export const LibraryTypes = {
  BOILERPLATE: 'boilerplate',
  UI_LIBRARY: 'ui-library',
  SERVER_LIBRARY: 'server-library',
};
